import React, { useState, useEffect, useRef } from "react"
import ReactHtmlParser from "react-html-parser"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import Svg from "../_svgs/svg"

export default function ImpressionHeroBlockComponent({ icon, video, image, title, introText, label, bottomPadding, topPadding, background }) {
  const iconSrc = SelectionFactoryHelper.getFromSelectionFactory(icon)
  const backgroundColor = SelectionFactoryHelper.getFromSelectionFactory(background)

  const videoExists = video ? true : false
  //if we dont end up using a hook, just remove it.
  const [showBackgroundVideo, setShowBackgroundVideo] = useState(true)
  const bgVideoRef = useRef(null)
  const isFirstRender = useRef(true)
  const tp = SelectionFactoryHelper.getFromSelectionFactory(topPadding)
  const bp = SelectionFactoryHelper.getFromSelectionFactory(bottomPadding)

  useEffect(() => {
    if (videoExists) {
      const bgVideo = bgVideoRef.current

      const playBgVideo = () => {
        bgVideo.currentTime = 0
        bgVideo
          .play()
          .then(() => {})
          .catch((error) => {
            console.error("Playback failed: ", error)
          })
      }

      const handleCanPlay = () => {
        if (bgVideo.readyState >= 4) {
          playBgVideo()
          bgVideo.removeEventListener("canplaythrough", handleCanPlay)
        }
      }

      bgVideo.addEventListener("canplaythrough", handleCanPlay)

      bgVideo.load()

      // Cleanup function to remove event listener
      return () => {
        bgVideo.removeEventListener("canplaythrough", handleCanPlay)
      }
    }
  }, [])

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
    if (videoExists) {
      const bgVideo = bgVideoRef.current

      const resetAndPlayBgVideo = () => {
        bgVideo.pause()
        bgVideo.currentTime = 0
        bgVideo
          .play()
          .then(() => {})
          .catch((error) => {
            console.error("Playback failed: ", error)
          })
        bgVideo.removeEventListener("canplaythrough", resetAndPlayBgVideo)
      }

      if (bgVideo) {
        if (bgVideo.readyState >= 4) {
          resetAndPlayBgVideo()
        } else {
          bgVideo.addEventListener("canplaythrough", resetAndPlayBgVideo)
        }
      }

      // Cleanup function to remove event listener
      return () => {
        if (bgVideo) {
          bgVideo.removeEventListener("canplaythrough", resetAndPlayBgVideo)
        }
      }
    }
  }, [showBackgroundVideo])

  return (
    <div className={`impression-hero-block-container ${tp ? tp : ""} ${bp ? bp : ""} ${background && background[0] ? background[0]?.value : ""}`}>
      <div className={"w--wider"}>
        {videoExists ? (
          <div className="video-wrapper">
            <video
              className="background-video"
              ref={bgVideoRef}
              data-epi-property="Video"
              loop
              muted
              playsInline
              preload={"auto"}
              loading="eager"
              fetchPriority="high"
              id={"videoHero"}
              src={video}
            >
              <source media="(max-width:767px)" src={video} />
            </video>
          </div>
        ) : (
          <picture className="background-pic">
            <source media="(max-width:767px)" srcSet={image} />
            <img src={image} data-epi-property="Image" id={"imgHero"} />
          </picture>
        )}
        <div className="text-layer">
          <div className="content">
            <Svg iconName={iconSrc} fillColor={"none"} stroke={"#071143"} />
            <div className="category">{label}</div>
            <div data-epi-property="Title" className="rich-text">
              {ReactHtmlParser(title)}
              {ReactHtmlParser(introText)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
